import { useMutation } from '@tanstack/react-query';
import { signup } from 'api/auth';
import Button from 'components/Button';
import TextInput from 'components/Form/TextInput';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Signup() {

    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const { mutate, status } = useMutation({
        mutationFn: signup,
        onSuccess: () => {
            return navigate('/')
        },
        onError: (error) => {
            if (error.response?.status === 400) {
                return setError('Email o password errati')
            }
            if (error.response?.status === 404) {
                return setError('Utente non trovato')
            }
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        if (e.target.password.value !== e.target.confirmPassword.value) {
            return setError('Le password non corrispondono')
        }

        const formData = {
            email: e.target.email.value,
            password: e.target.password.value,
            firstname: e.target.firstname.value,
            lastname: e.target.lastname.value
        }

        return mutate({
            data: formData
        })
    }

    return (
        <>
            <div className={`fixed top-0 left-0 right-0 bottom-0 bg-verylight flex items-center justify-center overflow-scroll p-10`}>
                <div className='p-10 box-border'>
                    <div className='bg-white border border-light p-10 box-border w-[400px] max-w-[94vw] rounded-sm'>
                        <img src="/images/opificioai-logo.png" alt="OpificioAI Logo" className='w-30 mx-auto mt-4'/>

                        <p className='pt-8 text-center'>
                            Registrazione
                        </p>

                        <form onSubmit={onSubmitHandler} className='pt-12 flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                type="text"
                                name="firstname"
                                placeholder="Nome"
                                required
                            />
                            <TextInput
                                label="Cognome"
                                type="text"
                                name="lastname"
                                placeholder="Cognome"
                                required
                            />
                            <TextInput
                                label="Email"
                                type="text"
                                name="email"
                                placeholder="Email"
                                required
                            />
                            <TextInput
                                label="Password"
                                type="password"
                                name="password"
                                placeholder="Password"
                                required
                            />
                            <TextInput
                                label="Conferma password"
                                type="password"
                                name="confirmPassword"
                                placeholder="Conferma password"
                                required
                            />

                            {error && 
                                <p className='text-red text-center mt-3'>{error}</p>
                            }

                            <div className='pt-4'>
                                <Button submit className='w-full'>{status === 'loading' ? 'Caricamento...' : 'Registrati'}</Button>
                            </div>
                        </form>
                    </div>

                    <p className='block text-center text-sm text-muted pt-6'>
                        Hai già un account? <Link to="/user/login" className='text-black hover:underline'>Accedi</Link>
                    </p>
                </div>
            </div>
        </>
    )
}
